import React from 'react';
import { Popover, PopoverTitle, PopoverContent } from 'reactstrap';
import {CompactPicker} from 'react-color';

export default class outPut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen : false
        }
    }

    render() {
        var id = "colorPicker_" + Math.floor((Math.random() * 100) + 1);
        return (
            <div>
                <div onClick={() => { this.setState({ popoverOpen: !this.state.popoverOpen }) }} id={id} style={{ borderStyle: "solid", borderWidth: "1px", width: "28px", height: "28px", padding: "3px", textAlign: "center", borderRadius: "5px", borderColor: "#cccccc" }}>
                    <div style={{ backgroundColor: this.props.color, width: "20px", height: "20px" }}>
                    </div>
                </div>
                <Popover placement="bottom" isOpen={this.state.popoverOpen} target={id} toggle={() => this.setState({ popoverOpen: !this.state.popoverOpen })}>
                    <CompactPicker color={this.props.color} onChange={(color) => {this.props.callBack(color)}} />
                </Popover>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/colorPicker.js